import _ from 'lodash';

export const requireCustomQuote = (parameters) => {
  const parametersList = [
    'blind_buried_hole',
    'min_trace_space',
    'controlled_dielectric',
    'smallest_hole_size',
  ];

  const found = _.find(parametersList, (prm) => {
    const val = parameters[prm];
    return val !== undefined && val !== '' && val !== '0';
  });
  return found !== undefined;
};


